module.exports = __webpack_public_path__ + "media/images/armoiries-7eec2a7a804328db59eb70cea27237fd.png";